function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-66bdd89f\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import \\\"./src/styles/index.scss\\\";\",\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./pickUpEdit.vue")
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-66bdd89f\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import \\\"./src/styles/index.scss\\\";\",\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./pickUpEdit.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../assets/js/userCenter/pickup/pickUpEdit.js"
import __vue_script__ from "!!babel-loader!../../../assets/js/userCenter/pickup/pickUpEdit.js"/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-66bdd89f\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./pickUpEdit.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66bdd89f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/userCenter/pickUp/pickUpEdit.vue
// module id = null
// module chunks = 